/** Business calendar: the organisation's time zone, working days, hours and holidays (ADR-0065). */
export default {
  en: {
    tab: "Business calendar",
    intro: "Set your organisation's time once. It is used for:",
    usedBy: {
      cases: "case and task response times (only working hours count);",
      schedules: "agents that run on a schedule, when they have no time zone of their own;",
      channels: "contact channels (quiet hours and weekend).",
    },
    readOnly: "Only case administrators and team admins can change the calendar.",
    updated: "Last changed {{at}} by",
    defaults: "Not changed yet: the defaults are Sunday to Thursday, 08:00–17:00, Asia/Riyadh.",
    timezone: "Time zone",
    timezoneHelp: "Times on screens and due dates use this time zone.",
    workingDays: "Working days",
    weekendIs: "The weekend is {{days}}.",
    noWeekend: "Every day is a working day.",
    dayStart: "Working day starts",
    dayEnd: "Working day ends",
    holidays: "Holidays",
    holidaysHelp: "No working time is counted on these days.",
    holidayPick: "Holiday date",
    addHoliday: "Add holiday",
    removeHoliday: "Remove holiday {{day}}",
    noHolidays: "No holidays added.",
    preview: {
      title: "Check it",
      ask: "If something must be answered within",
      dueBy: "it is due by {{when}} ({{zone}}).",
      loading: "Working out the due date…",
      failed: "The due date could not be worked out.",
    },
    save: "Save calendar",
    saved: "Business calendar saved",
    issues: {
      timezone_required: "Choose a time zone.",
      timezone_unknown: "Choose a time zone from the list.",
      no_working_days: "Choose at least one working day.",
      hours_order: "The working day must start before it ends.",
    },
  },
  ar: {
    tab: "تقويم العمل",
    intro: "اضبط توقيت جهتك مرة واحدة. يُستخدم في:",
    usedBy: {
      cases: "مدد الرد على الحالات والمهام (تُحتسب ساعات العمل فقط)؛",
      schedules: "الوكلاء الذين يعملون وفق جدول زمني إذا لم تكن لهم منطقة زمنية خاصة؛",
      channels: "قنوات التواصل (ساعات الهدوء وعطلة نهاية الأسبوع).",
    },
    readOnly: "لا يغيّر التقويم إلا مسؤولو الحالات ومسؤولو الفريق.",
    updated: "آخر تغيير {{at}} بواسطة",
    defaults: "لم يُغيَّر بعد: الافتراضي من الأحد إلى الخميس، 08:00–17:00، بتوقيت الرياض.",
    timezone: "المنطقة الزمنية",
    timezoneHelp: "تُعرض الأوقات وتواريخ الاستحقاق بهذه المنطقة الزمنية.",
    workingDays: "أيام العمل",
    weekendIs: "عطلة نهاية الأسبوع: {{days}}.",
    noWeekend: "كل الأيام أيام عمل.",
    dayStart: "بداية يوم العمل",
    dayEnd: "نهاية يوم العمل",
    holidays: "العطل الرسمية",
    holidaysHelp: "لا يُحتسب وقت عمل في هذه الأيام.",
    holidayPick: "تاريخ العطلة",
    addHoliday: "إضافة عطلة",
    removeHoliday: "إزالة العطلة {{day}}",
    noHolidays: "لم تُضف عطل.",
    preview: {
      title: "تحقّق",
      ask: "إذا وجب الرد خلال",
      dueBy: "فموعد الاستحقاق {{when}} ({{zone}}).",
      loading: "جارٍ حساب موعد الاستحقاق…",
      failed: "تعذّر حساب موعد الاستحقاق.",
    },
    save: "حفظ التقويم",
    saved: "حُفظ تقويم العمل",
    issues: {
      timezone_required: "اختر منطقة زمنية.",
      timezone_unknown: "اختر منطقة زمنية من القائمة.",
      no_working_days: "اختر يوم عمل واحدًا على الأقل.",
      hours_order: "يجب أن يبدأ يوم العمل قبل أن ينتهي.",
    },
  },
};
